<div style="width:100%" fxLayoutAlign="space-between start">
  <div class="titletxt">
    {{title}}
  </div>
  <div fxLayoutAlign="end">
    <button *ngIf="canShowClearFilter" mat-stroked-button class="btnNavBar" (click)="$event.stopPropagation();onClearFilters();"  tooltip="Réinitialiser les filtres">
      <mat-icon>autorenew</mat-icon>
      <span fxHide fxShow.gt-md>{{'Réinitialiser les filtres' | ellipsis:'Réinitialiser les filtres'.length}}</span>
    </button>
    <button *ngIf="canShowPanelFilter" mat-stroked-button class="btnNavBar" (click)="$event.stopPropagation();onShowFilter();">
      <mat-icon *ngIf="panelOpenState">visibility_off</mat-icon>
      <span  fxHide fxShow.gt-md *ngIf="panelOpenState">Masquer les filtres avancés</span>

      <mat-icon *ngIf="!panelOpenState">visibility_on</mat-icon>
      <span  fxHide fxShow.gt-md *ngIf="!panelOpenState">Afficher les filtres avancés</span>
    </button>
    <button *ngIf="canCreateNewExcel" mat-stroked-button class="btnNavBarColor" (click)="$event.stopPropagation();onNew();" tooltip="Création d'un {{subtitle}}">
      <mat-icon>add</mat-icon>
      <span fxHide fxShow.gt-md>Création</span>
    </button>
    <button *ngIf="canImportExcel" mat-stroked-button class="btnNavBarColor" (click)="$event.stopPropagation();onImport();" tooltip="Importer des {{subtitle}}s">
      <mat-icon>cloud_upload</mat-icon>
      <span fxHide fxShow.gt-md>Importer</span>
    </button>
    <button *ngIf="canConfigure" mat-stroked-button class="btnNavBarColor" (click)="$event.stopPropagation();onSettings();" tooltip="Configurer">
      <mat-icon>settings_suggest</mat-icon>
      <span fxHide fxShow.gt-md>Configurer</span>
    </button>
    <button *ngIf="canExportExcel" mat-stroked-button class="btnNavBarColor" (click)="$event.stopPropagation();onExportAsExcel();" tooltip="Exporter au format excel">
      <mat-icon>download</mat-icon>
      <span class="long-btn-span" fxHide fxShow.gt-md>Exporter sur Excel</span>
    </button>
    <button *ngIf="canCreateManualInvoice" mat-stroked-button class="btnNavBarColor" (click)="$event.stopPropagation();onCreateManualInvoice();" tooltip="Création d'une facture en mode manuel">
      <mat-icon>add_circle</mat-icon>
      <span class="long-btn-span large" fxHide fxShow.gt-md>Création manuelle de facture</span>
    </button>
  </div>
</div>
